/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { RedirectToLastVisitedProjectPage } from '@jira/router-routes__common/src/ui/last-visited-project-page/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { genericProjectLayout } from '@jira/platform__layouts-generic-project-layout/src/index.tsx';
import { AsyncHorizontalNavJira } from '@jira/navigation-apps__horizontal-nav-jira/src/async.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { rapidboardLastVisitedProjectRedirectRoute } from '@jira/router-routes__classic-projects-routes/src/rapidboardLastVisitedProjectRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const rapidboardLastVisitedProjectRedirectRouteEntry: Route = createEntry(
	rapidboardLastVisitedProjectRedirectRoute,

	() => ({
		group: 'classic-software',
		// eslint-disable-next-line no-restricted-syntax
		component: RedirectToLastVisitedProjectPage,
		layout: genericProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			horizontal: AsyncHorizontalNavJira,
		},

		isRedirect: true,
		resources: [...getNavigationResources()],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
